import React, { ReactNode, useContext, useEffect, useState } from 'react';

import OrgNetSuiteKeysContext from '@totem/components/orgManagement/orgDetails/netSuiteKeys/applied/orgNetSuiteKeysContext';
import { OrganizationNetSuiteCustomers } from '@totem/components/orgManagement/orgDetails/netSuiteKeys/types';
import { Organization } from '@totem/components/orgManagement/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { ORGANIZATION_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  organization: Organization;
  children?: ReactNode;
};

const OrgNetSuiteKeysContainer = ({ children, organization }: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [data, setData] = useState<OrganizationNetSuiteCustomers>([]);

  useEffect(() => {
    setRefreshData(true);
  }, [userProfile.organization.id, organization]);

  useEffect(() => {
    if (!refreshData) {
      return;
    }
    setRefreshData(false);

    fetch(`${ORGANIZATION_ENDPOINT}/${organization.id}/customers`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: OrganizationNetSuiteCustomers) => {
        setData(result);
      });
  }, [refreshData]);

  return (
    <OrgNetSuiteKeysContext.Provider
      value={{
        customers: data,
        onRefresh: () => setRefreshData(true),
      }}
    >
      {children}
    </OrgNetSuiteKeysContext.Provider>
  );
};

export default OrgNetSuiteKeysContainer;
